module.exports = __webpack_public_path__ + "img/no_data.38c56f0c.png";